export default {"src":"/_next/static/media/Refresh.bde36904.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};